module.exports = __webpack_public_path__ + "static/img/news3.61948f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/news3.png
// module id = HTHX
// module chunks = 52